module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-summer-2400.7661dd3f.svg";